/**
 * Product specific functions
 */

/**
 * Generate a fake internet product
 * @param index
 * @returns object
 */
export function generateFakeProduct(index) {
    let logoSlug = 'ziggo';

    if (index === 0) {
        logoSlug = 'nlex';
    } else if (index === 1) {
        logoSlug = 't-mobile';
    }

    return {
        rank: index,
        base_id: index,
        base_name: 'Voorbeeld abonnement',
        provider: 'ziggo',
        provider_id: 2,
        provider_name: 'Ziggo',
        provider_logo: `https://internetvergelijker.keuze.nl/logo/provider/${logoSlug}`,
        contract_duration: 12,
        contract_duration_text: '1 jaar',
        base_price: 46.5,
        base_price_initial: 35,
        discount_price: 28.5,
        discount_amount: 53,
        discount_amount_initial: 35,
        discount_amount_monthly: 18,
        discount_price_initial: 0,
        discount_duration: 9,
        discount_cashback: null,
        discount_type: 'new_price',
        combi_discount: null,
        combi_product: null,
        total_price_initial: 0,
        total_price: 46.5,
        total_price_discounted: 28.5,
        total_price_contract: 396,
        compare_price: 396,
        package_type: 'it',
        installation_support: 'paid',
        shipping_time: 30,
        speed_delivery: false,
        internet: {
            speed_down: 100,
            speed_down_expected: 100,
            speed_up: 10,
            connection: 'dsl',
            extra: {
                hotspots: false,
                security: null,
                wifi_repeater: false,
            },
        },
        tv: {
            included: true,
            available: [],
            enabled: [],
            channel_count: 70,
            channel_count_hd: 44,
            extra: {
                video_on_demand: true,
                tv_app: true,
            },
        },
        phone: {
            included: false,
            number_retention: false,
            tariff_start: 0,
            tariff_minute_fixed: 0,
            tariff_minute_mobile: 0,
        },
        additional: {
            enabled: [],
            available: [],
        },
        offer: null,
        discount_text: 'Nu 9 maanden voor € 28,50',
        upsells: [],
        cval: 1,
        provider_url: null,
        signup_url: null,
    };
}

/**
 * Translate a connection slug to a friendly label
 * @param typeSlug
 * @returns {string|*}
 */
export function connectionTypeLabel(typeSlug) {
    if (typeSlug === 'dsl') {
        return 'ADSL';
    } if (typeSlug === 'fiber') {
        return 'glasvezel';
    } if (typeSlug === 'cable') {
        return 'kabel';
    } if (typeSlug === '4g') {
        return '4G';
    } if (typeSlug === '5g') {
        return '5G';
    }
    return typeSlug;
}
